var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassrose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 154,
    viewBox: "0 0 155 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.6505,
    cy: 76.6505,
    r: 66.1505,
    stroke: "#9E9E9E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2678,
    cy: 76.2678,
    r: 55.7678,
    stroke: "#9E9E9E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2008,
    cy: 76.2008,
    r: 41.7008,
    stroke: "#9E9E9E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.1148,
    cy: 77.1148,
    r: 23.6148,
    stroke: "#9E9E9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 30L125.445 123.445",
    stroke: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6741 123.253L125.119 29.8085",
    stroke: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 143V10.8492",
    stroke: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 77H144.151",
    stroke: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6087 2.016H80.4557V7H79.7837L77.0957 3.507V7H76.2557V2.016H76.9277L79.6087 5.502V2.016Z",
    fill: "#9E9E9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24943 74.016H9.11743L7.35343 79H6.61843L5.36543 75.416L4.09843 79H3.36343L1.60643 74.016H2.52343L3.76943 77.733L5.06443 74.016H5.70843L6.97543 77.761L8.24943 74.016Z",
    fill: "#9E9E9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.099 79V74.016H151.431V74.73H148.981V76.109H151.284V76.823H148.981V78.286H151.431V79H148.099Z",
    fill: "#9E9E9E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3324 151.034C77.9497 151.034 77.5904 150.983 77.2544 150.88C76.9231 150.777 76.6407 150.63 76.4074 150.439L76.7154 149.781C76.9581 149.963 77.2101 150.098 77.4714 150.187C77.7374 150.271 78.0267 150.313 78.3394 150.313C78.6847 150.313 78.9507 150.252 79.1374 150.131C79.3287 150.01 79.4244 149.839 79.4244 149.62C79.4244 149.433 79.3357 149.291 79.1584 149.193C78.9857 149.09 78.6987 148.995 78.2974 148.906C77.6721 148.771 77.2171 148.596 76.9324 148.381C76.6477 148.166 76.5054 147.854 76.5054 147.443C76.5054 147.149 76.5847 146.888 76.7434 146.659C76.9021 146.43 77.1261 146.251 77.4154 146.12C77.7094 145.989 78.0477 145.924 78.4304 145.924C78.7804 145.924 79.1117 145.978 79.4244 146.085C79.7417 146.188 80.0007 146.332 80.2014 146.519L79.9004 147.177C79.4571 146.822 78.9671 146.645 78.4304 146.645C78.1084 146.645 77.8541 146.713 77.6674 146.848C77.4807 146.979 77.3874 147.158 77.3874 147.387C77.3874 147.583 77.4691 147.732 77.6324 147.835C77.8004 147.938 78.0851 148.033 78.4864 148.122C78.9017 148.22 79.2401 148.327 79.5014 148.444C79.7627 148.556 79.9634 148.703 80.1034 148.885C80.2434 149.062 80.3134 149.286 80.3134 149.557C80.3134 149.856 80.2341 150.117 80.0754 150.341C79.9167 150.56 79.6881 150.731 79.3894 150.852C79.0907 150.973 78.7384 151.034 78.3324 151.034Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassrose2);
export default __webpack_public_path__ + "static/media/compassrose-2.a59416fc33f05dee7121532e28267fbe.svg";
export { ForwardRef as ReactComponent };